import CommunityImage from './CommunityImage';

export default CommunityImage;
